export const isUrl = (input: string): boolean => {
  try {
    const _ = new URL(input);
  } catch {
    return false;
  }

  return true;
};
